function buyButtons() {
  const target = document.querySelector('.track-btns__position');
  
  if (!target) return;
  
  const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting && window.scrollY > 300) {
        document.body.classList.add('stick-buy-buttons');
      } else {
        document.body.classList.remove('stick-buy-buttons');
      }
    },
    {
      root: null,   
      threshold: 0   
    }
  );

  observer.observe(target);
}

function footerInView() {
   const target = document.querySelector('.shopify-section-group-footer-group');

    if (!target) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          document.body.classList.add('footer-visible');
        } else {
          document.body.classList.remove('footer-visible');
        }
      },
      {
        threshold: 0.1, 
      }
    );

    observer.observe(target);
}

function trackSecondaryLogo() {
  const target = document.querySelector(".track-for-header-logo");

  if (!target) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        document.body.classList.add("secondary-logo--visible");
      } else {
        document.body.classList.remove("secondary-logo--visible");
      }
    },
    {
      root: null, // viewport
      threshold: 0.01, // triggers when even 1% is visible
    }
  );

  observer.observe(target);
}

function headerStuck() {
  const header = document.querySelector('.shopify-section-header-sticky');

  if (!header) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (!entry.isIntersecting) {
        document.body.classList.add('header--stuck');
      } else {
        document.body.classList.remove('header--stuck');
      }
    },
    { 
      root: null,
      threshold: 0,
      rootMargin: `0px 0px -${header.offsetHeight}px 0px`,
    }
  );

  observer.observe(header);
}

function startMarquee(selector, speed = 1) {
  const container = document.querySelector(selector);
  const track = container.querySelector('.sliding__track');

  if (!container || !track) return;

  track.innerHTML += track.innerHTML;

  let pos = 0;

  function animate() {
    pos -= speed;
    track.style.transform = `translateX(${pos}px)`;

    if (Math.abs(pos) >= track.scrollWidth / 2) {
      pos = 0;
    }

    requestAnimationFrame(animate);
  }

  animate();
}

function mobileLink() {
  const shopAllButtons = document.querySelectorAll("summary[data-location]");

  shopAllButtons.forEach((button) => {
    button.addEventListener("click", function (e) {
      if (window.innerWidth <= 768) {
        e.preventDefault();
        const location = button.getAttribute("data-location");
        if (location) {
          window.location.href = location;
        }
      }
    });
  });
}

function variantPlacement() {
  const desktopBreakpoint = 1024;
  const isDesktop = window.innerWidth >= desktopBreakpoint;

  if (isDesktop) {
    const variantSelects = document.querySelector('.product__details--mob-title variant-selects');
    const desktopPicker = document.querySelector('.desktop-variant-picker');

    if (variantSelects && desktopPicker) {
      desktopPicker.appendChild(variantSelects);
    }
  }
}

function zoomGallery() {
  const imageContainer = document.querySelectorAll(".product--media--main img");
  const popupWrap = document.querySelector(".media__popup-wrap");
  const popupMain = document.querySelector(".media__popup--main .zoomed--img");
  const closeButton = document.querySelector(".close_icon");

  if (!imageContainer.length || !popupWrap || !popupMain || !closeButton) {
    console.warn("zoomGallery: Required elements are missing in the DOM.");
    return;
  }

  imageContainer.forEach((img) => {
    let startX = 0;
    let startY = 0;
    let isDragging = false;

    // Mouse
    img.addEventListener("mousedown", (e) => {
      startX = e.clientX;
      startY = e.clientY;
      isDragging = false;
    });

    img.addEventListener("mousemove", (e) => {
      if (Math.abs(e.clientX - startX) > 5 || Math.abs(e.clientY - startY) > 5) {
        isDragging = true;
      }
    });

    img.addEventListener("mouseup", (e) => {
      if (!isDragging) {
        const imgSrc = img.getAttribute("src");
        if (imgSrc) {
          popupMain.innerHTML = `<img src="${imgSrc}" class="media_popup" alt="Zoomed image"/>`;
          popupWrap.style.display = "block";
        }
      }
    });

    // Touch
    img.addEventListener("touchstart", (e) => {
      const touch = e.touches[0];
      startX = touch.clientX;
      startY = touch.clientY;
      isDragging = false;
    });

    img.addEventListener("touchmove", (e) => {
      const touch = e.touches[0];
      if (Math.abs(touch.clientX - startX) > 5 || Math.abs(touch.clientY - startY) > 5) {
        isDragging = true;
      }
    });

    img.addEventListener("touchend", () => {
      if (!isDragging) {
        const imgSrc = img.getAttribute("src");
        if (imgSrc) {
          popupMain.innerHTML = `<img src="${imgSrc}" class="media_popup" alt="Zoomed image"/>`;
          popupWrap.style.display = "block";
        }
      }
    });
  });

  closeButton.addEventListener("click", () => {
    popupWrap.style.display = "none";
  });
}

function handleize(str) {
  return str.toLowerCase().trim().replace(/['"]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');         
}

document.addEventListener('DOMContentLoaded', function(){
  footerInView();
  variantPlacement();
  buyButtons();
  trackSecondaryLogo();
  headerStuck();
  mobileLink();
  //zoomGallery();
});

$(document).ready(function () {
  $(".text__block--items").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    infinite: false,
  });
  
  /* Opening Act Fix - Issue #P04
  
  const $gallery = $(".product--media--wrapper");

  $gallery.slick({
    adaptiveHeight: true,
    swipe: true,
    cssEase: 'ease',
    touchMove: true,
    speed: 500,  
    centerMode: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    variableWidth: false,
    infinite: false,
    arrows: false,
    dots: true,
    buttons: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  
  document.addEventListener('variant:change', function (e) { 
    const titleHandle = handleize(e.detail.variant.title);

    const titleElement = document.querySelector(`.product--media--wrapper .${titleHandle}`);
    console.log(titleHandle, titleElement)
    if (!titleElement) return;

    const slideElement = titleElement.closest('[data-slick-index]');
    if (!slideElement) return;

    const index = parseInt(slideElement.dataset.slickIndex, 10);
    if (isNaN(index)) return;

    $gallery.slick('slickGoTo', index);
  });*/
 
  setTimeout(function () {
    $(".jdgm-prev-badge").after(
      '<span class="review-read_more">Read More</span>'
    );
  }, 2000);

  $(document).on("click", ".review_close", function (params) {
    $(".product_review-wrapper").hide();
    $(".product_review--main").removeClass("active");
    $("html").removeClass("overflow_hidden");
  });
  $(document).on("click", ".review-read_more", function (params) {
    $(".product_review-wrapper").show();
    $(".product_review--main").addClass("active");
    $("html").addClass("overflow_hidden");
    $("html").animate({ scrollTop: 0 }, "slow");
  });

  
  /*$('.product--media--wrapper').slick({
    slidesToShow: 2.5,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 1000,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2.5,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
      ]
});*/

  // var stickyWrapper = $(".home-banner");
  // var endPoint = $(".section-header");
  // if (stickyWrapper.length > 0) {
  //   var stickyWrapperOffset = stickyWrapper.offset().top + 250,
  //     endPointOffset = endPoint.offset().top,
  //     sticky_wrapper_text = $(".sticky-wrapper-text");
  //   if (sticky_wrapper_text > 0) {
  //     var stickytextOffset = sticky_wrapper_text.offset().top;
  //   }
  // }
  // var header_wrapp_offset = $(".header-wrapper").offset().top;

  // $(window).scroll(function () {
  //   var scrollPosition = $(window).scrollTop(),
  //     banner_height = $('[id*="Banner-sections--"]').height() || 100;
  //   console.log({ scrollPosition, banner_height });
  //   if (scrollPosition > banner_height) {
  //     $(".header-wrapper").addClass("header_sticky coll_header_sticky animate other_header_sticky");
  //   } else {
  //     $(".header-wrapper").removeClass(
  //       "header_sticky coll_header_sticky animate other_header_sticky"
  //     );
  //   }

  //   if (stickyWrapper.length > 0) {
  //     if (
  //       scrollPosition > stickyWrapperOffset &&
  //       scrollPosition < endPointOffset
  //     ) {
  //       stickyWrapper.addClass("sticky-top");
  //     } else {
  //       stickyWrapper.removeClass("sticky-top");
  //     }

  //     if (scrollPosition > stickytextOffset) {
  //       sticky_wrapper_text.addClass("sticky-heading");
  //     } else {
  //       sticky_wrapper_text.removeClass("sticky-heading");
  //     }
  //     console.log(
  //       header_wrapp_offset,
  //       "header_wrapp_offset",
  //       scrollPosition,
  //       "scrollPosition",
  //       stickyWrapperOffset
  //     );
  //     if (scrollPosition > stickyWrapperOffset + 600) {
  //       $(".header-wrapper").addClass("header_sticky");
  //     } else {
  //       $(".header-wrapper").removeClass("header_sticky");
  //     }
  //     if (scrollPosition > stickyWrapperOffset) {
  //       $(".template-collection .header-wrapper").addClass(
  //         "coll_header_sticky"
  //       );
  //     } else {
  //       $(".template-collection .header-wrapper").removeClass(
  //         "coll_header_sticky"
  //       );
  //     }
  //     if ($(window).width() > 749) {
  //       $(".animate--fade-out").css("opacity", 1 - $(window).scrollTop() / 600);
  //       if (scrollPosition > stickyWrapperOffset + 300) {
  //         $(".template-index .header-wrapper").addClass("animate");
  //       } else {
  //         $(".template-index .header-wrapper").removeClass("animate");
  //       }
  //     }
  //   }
  //   console.log(scrollPosition);
  //   if (!$("body").hasClass("template-index")) {
  //     if (scrollPosition > 10) {
  //       $(".header-wrapper").addClass("other_header_sticky");
  //     } else {
  //       $(".header-wrapper").removeClass("other_header_sticky");
  //     }
  //   }
  // });

  $(document).on("click", ".col-search_btn", function () {
    var searchText = $(this)
      .parents(".search__wrapper")
      .find("#search--bar")
      .val()
      .toLowerCase();
    $("#product-grid .grid__item").each(function () {
      var cardTitle = $(this)
        .find(".card__content .card__title")
        .text()
        .toLowerCase();
      console.log(cardTitle, "cardTitle");
      if (cardTitle.includes(searchText)) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  });
  $(document).on("input", "#search--bar", function () {
    var searchText = $(this).val().toLowerCase();
    $("#product-grid .grid__item").each(function () {
      var cardTitle = $(this)
        .find(".card__content .card__title")
        .text()
        .toLowerCase();
      console.log(cardTitle, "cardTitle");
      if (cardTitle.includes(searchText)) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  });
});


/* Opening Act Fix - Issue #P04 */

document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("productMediaModal");
  const modalContent = modal.querySelector(".image-modal-content");
  const gallery = document.getElementById("modalImageContainer");
  const closeModal = document.getElementById("closeModal");
  const prevArrow = modal.querySelector(".prev-arrow");
  const nextArrow = modal.querySelector(".next-arrow");
  const imageIndexText = modal.querySelector(".image-index");
  const slides = modal.querySelectorAll(".modal-slide");
  const buttons = document.querySelectorAll(".gallery-image-button");

  let currentIndex = 0;
  const totalImages = slides.length;

  function updateSlider(index) {
    currentIndex = index;
    gallery.style.transform = `translateX(-${index * 100}%)`;
    imageIndexText.textContent = `${index + 1} / ${totalImages}`;
  }

  // Open modal and show clicked image
  buttons.forEach((button, index) => {
    button.addEventListener("click", () => {
      modal.classList.add("open");
      updateSlider(index);
      document.body.classList.add("overflow-hidden");
    });
  });

  // Close modal via X button
  closeModal.addEventListener("click", () => {
    modal.classList.remove("open");
    document.body.classList.remove("overflow-hidden");
  });

  // Close modal when clicking outside the image or modal nav
  modal.addEventListener("click", (e) => {
    const isImage = e.target.classList.contains("image-modal-img");
    const isNav = e.target.closest(".image-modal-nav");

    if (!isImage && !isNav) {
      modal.classList.remove("open");
      document.body.classList.remove("overflow-hidden");
    }
  });
  

  // Arrow nav
  prevArrow.addEventListener("click", () => {
    if (currentIndex > 0) updateSlider(currentIndex - 1);
  });

  nextArrow.addEventListener("click", () => {
    if (currentIndex < totalImages - 1) updateSlider(currentIndex + 1);
  });

  // Swipe support
  let startX = 0;
  gallery.addEventListener("touchstart", (e) => {
    startX = e.touches[0].clientX;
  });
  gallery.addEventListener("touchend", (e) => {
    const deltaX = e.changedTouches[0].clientX - startX;
    if (deltaX > 50 && currentIndex > 0) updateSlider(currentIndex - 1);
    else if (deltaX < -50 && currentIndex < totalImages - 1) updateSlider(currentIndex + 1);
  });

  // Keyboard support
  document.addEventListener("keydown", (e) => {
    if (!modal.classList.contains("open")) return;
    if (e.key === "ArrowLeft" && currentIndex > 0) updateSlider(currentIndex - 1);
    else if (e.key === "ArrowRight" && currentIndex < totalImages - 1) updateSlider(currentIndex + 1);
    else if (e.key === "Escape") {
      modal.classList.remove("open");
      document.body.classList.remove("overflow-hidden");
    }
  });

  // Set initial state
  updateSlider(0);
});
